// Configuration Client - EMS Express Miroiterie Serrurerie
// CHARTE GRAPHIQUE : ROUGE ET BLANC
export const clientConfig = {
  company: {
    name: "EMS Express Miroiterie Serrurerie",
    shortName: "EMS Express",
    tagline: "Vitrerie • Serrurerie • Menuiserie",
    phone: "07 64 08 45 10",
    phoneEmergency: "07 64 08 45 10",
    email: "contact.ems94@gmail.com",
    address: "43 Rue Paul Bert",
    city: "Vitry-sur-Seine",
    postalCode: "94400",
    fullAddress: "43 Rue Paul Bert, 94400 Vitry-sur-Seine",
    domain: "ems-express-miroiterie.fr",
    logo: "https://customer-assets.emergentagent.com/job_miroir-service/artifacts/epczprr4_PHOTO-2026-01-08-14-12-18.jpg",
    openingHours: {
      weekdays: "09:00 - 19:00",
      emergency: "24h/24 - 7j/7"
    }
  },
  colors: {
    primary: "hsl(0, 75%, 45%)",
    primaryHex: "#B91C1C",
    primaryLight: "hsl(0, 75%, 55%)",
    primaryLightHex: "#DC2626",
    emergency: "hsl(0, 85%, 50%)",
    emergencyHex: "#EF4444",
    dark: "hsl(0, 0%, 15%)",
    darkHex: "#262626",
    light: "hsl(0, 0%, 98%)",
    lightHex: "#FAFAFA",
    accent: "hsl(0, 0%, 40%)",
    accentHex: "#666666",
    white: "#FFFFFF"
  },
  seo: {
    mainService: "vitrier",
    mainCity: "Vitry-sur-Seine",
    mainPostalCode: "94400",
    region: "Val-de-Marne",
    department: "94",
    googleAnalyticsId: ""
  },
  services: [
    { id: "vitrerie", name: "Vitrerie - Miroiterie", priority: 1 },
    { id: "serrurerie", name: "Serrurerie", priority: 2 },
    { id: "menuiserie", name: "Menuiserie", priority: 3 },
    { id: "urgence", name: "Dépannage Urgence 24h/24", priority: 4 },
    { id: "securisation", name: "Sécurisation Provisoire", priority: 5 },
    { id: "maintenance", name: "Maintenance & Prévention", priority: 6 }
  ],
  // VITRY-SUR-SEINE EN PREMIER (PRIORITÉ SEO)
  cities: [
    { id: "vitry-sur-seine", name: "Vitry-sur-Seine", postalCode: "94400", isPrimary: true },
    { id: "ivry-sur-seine", name: "Ivry-sur-Seine", postalCode: "94200", isPrimary: false },
    { id: "creteil", name: "Créteil", postalCode: "94000", isPrimary: false },
    { id: "villejuif", name: "Villejuif", postalCode: "94800", isPrimary: false },
    { id: "lhay-les-roses", name: "L'Haÿ-les-Roses", postalCode: "94240", isPrimary: false },
    { id: "fontenay-sous-bois", name: "Fontenay-sous-Bois", postalCode: "94120", isPrimary: false },
    { id: "nogent-sur-marne", name: "Nogent-sur-Marne", postalCode: "94130", isPrimary: false },
    { id: "maisons-alfort", name: "Maisons-Alfort", postalCode: "94700", isPrimary: false },
    { id: "choisy-le-roi", name: "Choisy-le-Roi", postalCode: "94600", isPrimary: false },
    { id: "chevilly-larue", name: "Chevilly-Larue", postalCode: "94550", isPrimary: false },
    { id: "orly", name: "Orly", postalCode: "94310", isPrimary: false },
    { id: "thiais", name: "Thiais", postalCode: "94320", isPrimary: false },
    { id: "limeil-brevannes", name: "Limeil-Brévannes", postalCode: "94450", isPrimary: false },
    { id: "villiers-sur-marne", name: "Villiers-sur-Marne", postalCode: "94350", isPrimary: false }
  ]
};

export default clientConfig;